<div class="performance-table-wrapper table-content-center">
  <div class="performance-table-spinner d-flex align-items-center justify-content-center" *ngIf="isShowLoader">
    <c11n-spinner [size]="'medium'" [colorMode]="'on-light'" [spinnerStatus]="'Loading...'"></c11n-spinner>
  </div>
  <div class="c11n-table__symbols">
  </div>
  <div *ngIf="!(performanceView.length === 0 && isDataAvailable)" id="performance-table-updated-announcement" class="sr-only" aria-live="polite">
    {{ updateMessage }}
  </div>
  <table
    c11n-data-table
    size="small" density="compact"
    [headerDividers]="true"
    [rowHighlight]="true" [stickyHeader]="true"
    [stickyFirstColumn]="true"
    (tableSortEvent)="handleSortEvent($event)"
    *ngIf="isShowTable"
    id="sortable-table"
    tabindex="-1"
    role="table"
    class="funds-table--wrapper"
    aria-label="This is a performance table summary"
    title="This is a performance table summary"
    data-cy="table-small">
    <thead class="c11n-text-sm table-header-sticky">
    <tr c11n-thead-tr>
      <td c11n-thead-td scope="col"></td>
      <td c11n-thead-td scope="col"></td>
      <td c11n-thead-td scope="col"></td>
      <th id="col-custom-date-message" data-rpa-tag-id="pf-mthEnd-asOfDate" scope="colgroup" colspan="6" c11n-thead-th alignment="center"
          [isSortable]="false" #groupHeaderRef>
        {{ performanceCaas['avgTotRet'] }} {{ annualAsOfDt | customDate }}
      </th>
      <td c11n-thead-td scope="col"></td>
      <td c11n-thead-td scope="col"></td>
      <td c11n-thead-td scope="col"></td>
    </tr>
    <tr c11n-thead-tr [stickyTop]="secondHeaderRowStickyTop">
      <th id="col-1-fund-name" scope="col" c11n-thead-th alignment="left" [isAscending]="true"
          [isSortable]="true">
        <span>{{ performanceCaas['fundName'] }}</span>
      </th>
      <th id="col-2-symbol" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span>{{ performanceCaas['symbol'] }}</span>
      </th>
      <th id="col-3-ytd-return" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <div data-rpa-tag-id="pf-daily-ytd-asOfDate" class="c11n-table__thead-th--info mt-2 text-nowrap">{{ performanceCaas.asof }} {{ ytdAsOf | customDate }}</div> <br/>
        <span class="text-nowrap">{{ performanceCaas['ytdReturn'] }}</span>
      </th>
      <th id="col-4-one-year" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span class="c11n-link__text text-nowrap">{{ performanceCaas['oneYear'] }}</span>
      </th>
      <th id="col-5-three-year" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span class="c11n-link__text text-nowrap">{{ performanceCaas['threeYear'] }}</span>
      </th>
      <th id="col-6-five-year" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span class="c11n-link__text text-nowrap">{{ performanceCaas['fiveYear'] }}</span>
      </th>
       <th id="col-7-ten-year" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span class="c11n-link__text text-nowrap">{{ performanceCaas['tenYear'] }}</span>
      </th>
      <th id="col-8-since-inception" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span class="c11n-link__text">{{ performanceCaas['sinceInception'] }}</span>
      </th>
      <th id="col-9-since-inception-date" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span class="c11n-link__text">{{ performanceCaas['inceptionDate'] }}</span>
      </th>
      <th id="col-10-expense-ratio" scope="col" c11n-thead-th alignment="left" [isSortable]="true" (focusin)="hovered = true">
        <span>{{ performanceCaas['expenseRatio'] }}</span>
      </th>
      <th id="col-11-sec-yield" scope="col" c11n-thead-th alignment="left" [isSortable]="true">
        <span tabindex="0" class="c11n-link__content text-nowrap sec-yield-label" (mouseenter)="hovered = true" (mouseleave)="hovered = false"
              (focusin)="openTooltip(secYieldTooltipRef)" (focusout)="openTooltip(secYieldTooltipRef); hovered = false">{{performanceCaas['secYield']}}
          <c11n-tooltip *ngIf="hovered" [colorMode]="'on-dark'" [align]="'end'" [direction]="'below'" [autoOrientation]="false"
                         class="sec-yield-tooltip" #secYieldTooltipRef>
            <div c11nTooltipContent class="c11n-text-sm" [innerHTML]="performanceCaas['sechover'].html"></div>
          </c11n-tooltip>
        </span>
      </th>
      <th id="col-12-download-fact-sheet" scope="col"  c11n-thead-th alignment="center"
          [isSortable]="false">
          <span tabindex="0" (focusout)="hovered = true" (focusin)="hovered = false">{{ performanceCaas['downloadFactsheet'] }}</span>
      </th>
    </tr>
    </thead>
    <tbody *ngIf="performanceView.length > 0 && isDataAvailable">
      <ng-container *ngFor="let performanceViewRow of performanceView | sort:sortBy; trackBy: trackById; index as i;">
        <tr tabindex="-1" [attr.data-rpa-tag-id]="'pf-' + performanceViewRow['symbol']" (focusout)="addTooltip(true,i)"
          data-cy="table-row-small-{{i}}" c11n-tbody-tr [ngClass]="isBenchmark ? 'fundDataNoBorder' : 'fundDataWithBorder'">
        <th id="fundNameValueAlpha{{i}}" c11n-tbody-th scope="row" class="fund-name">
          <a (focusout)="addTooltip(true,i)" href="{{productDetails}}{{performanceViewRow['fundID']}}"
             class="c11n-link c11n-link--secondary c11n-link--independent mt-1">
              <span class="c11n-link__content">
                <span data-rpa-tag-id="pf-longName" class="c11n-link__text">{{ performanceViewRow['fundName'] }}</span>
              </span>
          </a>
          <span *ngIf="performanceViewRow['closedIndicator']">&nbsp;</span>
          <img class="c11n-card--image-1-1 closed-Indicator" role="button" title="Closed"
               *ngIf="performanceViewRow['closedIndicator']" alt="Closed" src="{{performanceCaas['closedImage']}}">
          <div class="c11n-text fee-content">
            <em>
              <div class="c11n-link__text" *ngIf="performanceViewRow['purchaseFee']"
                   [innerHtml]="performanceCaas.purchaseFee + ': ' + (performanceViewRow['purchaseFee'] | percentage)"></div>
              <div class="c11n-link__text" *ngIf="performanceViewRow['redemptionFee']"
                   [innerHtml]="performanceCaas.redemptionFee + ': ' + (performanceViewRow['redemptionFee'] | percentage)"></div>
            </em>
          </div>
        </th>
        <td data-rpa-tag-id="pf-symbol" id="symbolValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['symbol'] }}
        </td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-nav-daily-ytd-pct' : 'pf-mkt-daily-ytd-pct'" id="YTDValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['ytdReturns'] | percentage }}
          <span class="sr-only" *ngIf="!performanceViewRow['ytdReturns']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-nav-pct-mthEnd-1yr' : 'pf-mkt-pct-mthEnd-1yr'" id="oneyearValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['oneyear'] | percentage }}
          <span class="sr-only" *ngIf="!performanceViewRow['oneyear']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-nav-pct-mthEnd-3yr' : 'pf-mkt-pct-mthEnd-3yr'" id="threeyearValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['threeyear'] | percentage }}
          <span class="sr-only" *ngIf="!performanceViewRow['threeyear']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-nav-pct-mthEnd-5yr' : 'pf-mkt-pct-mthEnd-5yr'" id="fiveyearValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['fiveyear'] | percentage }}
          <span class="sr-only" *ngIf="!performanceViewRow['fiveyear']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-nav-pct-mthEnd-10yr' : 'pf-mkt-pct-mthEnd-10yr'" id="tenyearValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['tenyear'] | percentage }}
          <span class="sr-only" *ngIf="!performanceViewRow['tenyear']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-nav-pct-mthEnd-sinceInception' : 'pf-mkt-Pct-mthEnd-sinceInception'" id="sinceyearValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['sinceInceptionRtn'] | percentage }}
          <span class="sr-only" *ngIf="!performanceViewRow['sinceInceptionRtn']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td data-rpa-tag-id="pf-InceptionDate" id="sinceInceptionRtnDate{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['sinceInceptionRtnDate'] | customDate }}
          <span class="sr-only" *ngIf="!performanceViewRow['sinceInceptionRtnDate']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td data-rpa-tag-id="pf-expenseRatio" id="expenseValueAlpha{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable">{{ performanceViewRow['expenseRatio'] | expenseRatioValue }}
          <span class="sr-only" *ngIf="!performanceViewRow['expenseRatio']"> &nbsp;{{ dataUnavailable }}</span>
        </td>
        <td *ngIf="!performanceViewRow['secYield'].isNote" id="secYield{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable secYValueStyle alignRight">
          <div data-rpa-tag-id="pf-secYield-pct" class="sec_text-details" [ngClass]="{'sec_text-border':(performanceViewRow['secYield'].yieldPct)}">
            {{ (performanceViewRow['secYield'].yieldPct || '' | percentage) + " " }}
            <a role="button" c11n-link fontWeight="normal" href="javascript:void(0)"
               aria-label="{{performanceViewRow['secYield'].secYieldFootNoteCode}}"
               *ngIf="performanceViewRow['secYield'].showSecPopup" class="cursorPointer accessibility-no-border"
               (click)="setPopupData(performanceViewRow); footNoteCodeModalDialog.openModalDialog($event)">
              <sup data-rpa-tag-id="pf-secYield-footNote" class="secYieldFootNoteCode"
                   [innerHtml]="performanceViewRow['secYield'].secYieldFootNoteCode"></sup></a>
            <span
              *ngIf="!performanceViewRow['secYield'].showSecPopup && performanceViewRow['secYield'].secHighYieldLayer">
       <sup data-rpa-tag-id="pf-secYield-footNote" tabindex="0" (keydown.enter)="addTooltip(true,i);openTooltip(tooltipRef)" (mouseenter)="addTooltip(true,i)" (focusin)="addTooltip(true,i);openTooltip(tooltipRef)"
            (focusout)="addTooltip(false,i); openTooltip(tooltipRef)" class="secYieldFootNoteCode"> {{ performanceViewRow['secYield'].secYieldFootNoteCode }}</sup>
      <c11n-tooltip *ngIf="hoveredRowIndex === i" (mouseleave)="removeTooltip(false,i)" [colorMode]="'on-dark'"
                    [align]="'end'" [direction]="'below'" [autoOrientation]="false" [labelText]="performanceViewRow['secYield'].secYieldFootNoteCode"
                    class="sec-yield-code-tooltip" #tooltipRef>
        <div data-rpa-tag-id="pf-secYield-footNote" role="alert" c11nTooltipContent class="c11n-text-sm text-content"
             [innerHtml]="'<b>' + performanceViewRow['secYield'].secYieldFootNoteCode + '</b>' +'<br>'+ performanceViewRow['secYield'].secHighYieldLayer"></div>
      </c11n-tooltip>
      </span>
            <div data-rpa-tag-id="pf-secYield-text" *ngIf="performanceViewRow['secYield'].yieldPct"
                 [innerHtml]="performanceViewRow['secYield'].day"></div>
            <div data-rpa-tag-id="pf-secYield-asOfDate" *ngIf="performanceViewRow['secYield'].yieldPct"
                 [innerHtml]="performanceViewRow['secYield'].asOfDt | customDate"></div>
          </div>
        </td>
        <td *ngIf="performanceViewRow['secYield'].isNote" id="secYield1{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable padding-right-40px">
          <div class="sec_text-details" [ngClass]="{'sec_text-border':(performanceViewRow['secYield'].yieldPct)}">
            <a role="button" c11n-link fontWeight="normal" href="javascript:void(0)"
               aria-label="{{performanceViewRow['secYield'].secYieldFootNoteCode}}"
               *ngIf="performanceViewRow['secYield'].showSecPopup" class="accessibility-no-border"
               (click)="setPopupData(performanceViewRow); footNoteCodeModalDialog.openModalDialog($event) ">
                     <span data-rpa-tag-id="pf-secYield-footNote" class="secYieldFootNoteCode noteLine">
                       <span class="sr-only">{{ performanceViewRow['fundName'] }} &nbsp;</span>
                       {{ performanceViewRow['secYield'].secYieldFootNoteCode }}
                     </span>
            </a>
            <span data-rpa-tag-id="pf-secYield-footNote" *ngIf="!performanceViewRow['secYield'].showSecPopup"
                  [innerHtml]="performanceViewRow['secYield'].secYieldFootNoteCode">
         <c11n-tooltip [colorMode]="'on-dark'" [align]="'end'" [direction]="'below'" [autoOrientation]="false">
                    labelText="{{ performanceViewRow['secYield'].secYieldFootNoteCode }}"  class="sec-yield-code-tooltip">
                        <div data-rpa-tag-id="pf-secYield-footNote" c11nTooltipContent class="c11n-text-sm"
                             [innerHtml]="'<b>' + performanceViewRow['secYield'].secYieldFootNoteCode + '</b>' +'<br>'+ performanceViewRow['secYield'].secHighYieldLayer"></div>&ndash;&gt;
                     </c11n-tooltip>
                      </span>
          </div>
        </td>
        <td class="c11n-table__td c11n-table__td--align-center">
          <span *ngIf="isFundLiteratureDataAvailable">
                      <c11n-icon-button *ngIf="performanceViewRow.factSheetUrl" class="d-flex justify-content-center"
                                        iconName="document" size="small" variant="ghost" scale="large"
                                        (clickEvent)="downLoadPdf(performanceViewRow.factSheetUrl)" labelText= "{{performanceViewRow['fundName']}} {{factSheetTooltip}}">
                       </c11n-icon-button>
          <span tabindex="0" *ngIf="!performanceViewRow.factSheetUrl">{{ performanceCaas.notAvailable }}
            <span class="sr-only">&nbsp; {{ NOT_AVAILABLE }}</span>
          </span>
          </span>
          <span *ngIf="!isFundLiteratureDataAvailable">
             {{ emDash }}
            <span class="sr-only" *ngIf="isFundLiteratureDataAvailable"> &nbsp;{{ dataUnavailable }}</span>
          </span>
        </td>
      </tr>
        <tr [attr.data-rpa-tag-id]="'pf-' + performanceViewRow['symbol'] + '-benchmark'" tabIndex="-1" c11n-tbody-tr class="benchmark__tr" *ngIf="isBenchmark">
        <th id="benchmarkName{{i}}" c11n-tbody-th scope="row" alignment="left" class="bench-mark-bg">
          <div [attr.data-rpa-tag-id]="'pf-benchmark-longName'" class="c11n-space--force c11n-space-inline-left-4x"
               *ngIf="performanceViewRow['benchmark'].benchmarkLongName !== null"
               [innerHtml]="performanceViewRow['benchmark'].benchmarkLongName"></div>
        </th>
        <td class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"></td>
        <td class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"></td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-benchmark-pct-mthEnd-1yr' : 'pf-mkt-pct-mthEnd-1yr'" id="benchmarkOneYear{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"
            [innerHtml]="((performanceViewRow['benchmark'].oneyear !== null) ? performanceViewRow['benchmark'].oneyear : '')  | percentage"></td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-benchmark-pct-mthEnd-3yr' : 'pf-mkt-pct-mthEnd-3yr'" id="benchmarkThreeYear{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"
            [innerHtml]="((performanceViewRow['benchmark'].threeyear !== null) ? performanceViewRow['benchmark'].threeyear : '')  | percentage"></td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-benchmark-pct-mthEnd-5yr' : 'pf-mkt-pct-mthEnd-5yr'" id="benchmarkFiveYear{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"
            [innerHtml]="((performanceViewRow['benchmark'].fiveyear !== null) ? performanceViewRow['benchmark'].fiveyear : '') | percentage"></td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-benchmark-pct-mthEnd-10yr' : 'pf-mkt-pct-mthEnd-10yr'" id="benchmarkTenYear{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"
            [innerHtml]="((performanceViewRow['benchmark'].tenyear !== null) ? performanceViewRow['benchmark'].tenyear : '')  | percentage"></td>
        <td [attr.data-rpa-tag-id]="viewType === 'monthEndReturnNAV' ? 'pf-benchmark-pct-mthEnd-sinceInception' : 'pf-mkt-Pct-mthEnd-sinceInception'" id="benchmarkSinceInceptionRtn{{i}}"
            class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"
            [innerHtml]="((performanceViewRow['benchmark'].sinceInceptionRtn !== null) ? performanceViewRow['benchmark'].sinceInceptionRtn : '')  | percentage"></td>
        <td class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-bg"></td>
        <td class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-no-bg"></td>
        <td class="c11n-table__td c11n-table__td--align-left c11n-table__td--sortable bench-mark-no-bg"></td>
        <td class="c11n-table__td c11n-table__td--sortable c11n-table__thead-td--align-center bench-mark-no-bg"></td>
      </tr>
    </ng-container>
    </tbody>
  </table>
  <br>
  <div *ngIf="performanceView.length === 0 && isDataAvailable">
    <fd3-banner-error></fd3-banner-error>
  </div>
</div>
<c11n-modal-dialog
  [modalId]="'footNoteCodeModalDialog'"
  [maxWidth]=1000
  [variant]="'basic'"
  [useContentWidth]='useContentWidth'
  [headingText]="fundNameData"
  #footNoteCodeModalDialog>
  <div
    [ngClass]="useContentWidth ? 'dialog-example-content-width' : 'dialog-example-default-width'"
    c11n-modal-dialog-body>
    <p class='c11n-text-sm-bold' [innerHTML]="notePopupPara"></p>
    <br>
    <p class='c11n-text-sm' [innerHTML]="fundCaasData"></p>
    <br>
    <p class="polaris-data-font" [innerHTML]="fundPolarisData"></p>
  </div>
</c11n-modal-dialog>
